import FuseLoadable from '@fuse/components/FuseLoadable/FuseLoadable'

export const CommercialiConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [
    {
      path: '/commerciali/gestione',
      component: FuseLoadable({
        loader: () => import('./ListaGestione')
      })
    },
    {
      path: '/commerciali/rinnovi',
      component: FuseLoadable({
        loader: () => import('./ListaRinnovi')
      })
    },
    {
      path: '/commerciali/assistenzaClienti',
      component: FuseLoadable({
        loader: () => import('./ListaAssistenzaClienti')
      })
    }
  ]
}
